import { createContext, useCallback, useContext, useState } from "react";
import RequestInvitationModal from "../RequestInvitationModal";

const InviteCtx = createContext(() => {});

export const useInvite = () => useContext(InviteCtx);

export const InviteProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const show = useCallback(() => setOpen(true), []);
  const hide = useCallback(() => setOpen(false), []);
  return (
    <InviteCtx.Provider value={show}>
      {children}
      <RequestInvitationModal open={open} onClose={hide} />
    </InviteCtx.Provider>
  );
};
